import { z } from 'zod';
import { D } from '../decimal.js';
import { DecimalStringSchema, IsoDateSchema } from './primitives.js';

// Zod 4 runs refinements even when a prior .regex() check failed — guard the
// Decimal construction so malformed input yields an issue, not a thrown error.
export const PositiveDecimalStringSchema = DecimalStringSchema.refine((value) => {
  try {
    return D(value).gt(0);
  } catch {
    return false;
  }
}, 'Le prix doit être strictement positif');

export const ManualPriceReasonSchema = z.string().trim().min(10).max(500);

export const ManualSpotPriceRequestSchema = z.object({
  assetId: z.number().int().positive(),
  timestamp: z.number().int().nonnegative(),
  priceEur: PositiveDecimalStringSchema,
  reason: ManualPriceReasonSchema,
});

export const ManualClosingPriceRequestSchema = z.object({
  assetId: z.number().int().positive(),
  date: IsoDateSchema,
  priceEur: PositiveDecimalStringSchema,
  reason: ManualPriceReasonSchema,
});

export const ManualClosingPriceResponseSchema = z
  .object({
    assetId: z.number().int().positive(),
    date: IsoDateSchema,
    currency: z.literal('EUR'),
    source: z.literal('manual'),
  })
  .strict();

export const SetPeggedPriceRequestSchema = z.object({
  priceEur: PositiveDecimalStringSchema.nullable(),
});

export type ManualSpotPriceRequest = z.infer<typeof ManualSpotPriceRequestSchema>;
export type ManualClosingPriceRequest = z.infer<typeof ManualClosingPriceRequestSchema>;
export type ManualClosingPriceResponse = z.infer<typeof ManualClosingPriceResponseSchema>;
export type SetPeggedPriceRequest = z.infer<typeof SetPeggedPriceRequestSchema>;
